<template lang="html">
  <d-form @submit.prevent="submit" :validated="hasErrors">
    <d-form-row class="mb-3">
      <d-col class="header text-center">
        <h3>{{ title }}</h3>
      </d-col>
      <d-col cols="12">
         <alert :fixed="false"></alert>
      </d-col>
    </d-form-row>

    <d-form-row v-for="(row, index) in form.rating.questions" :key="index" class="mt-3">
      <d-col>
        <label>{{ index + 1 }} - {{ row.question }}</label>
        <component :is="template[row.type]" :model.sync="row.value" :state="hasErrorFiled(row)"/>
        <d-form-invalid-feedback :forceShow="hasErrorFiled(row) === 'invalid'">Este campo é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row v-if="form.rating.questions.length > 0">
      <d-col class="mt-5">
        <d-button type="submit" :disabled="submitted">Enviar</d-button>
      </d-col>
    </d-form-row>

  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Alert from '_shared/Alert.vue';
import RatingService from '_services/rest/modules/rating';
import InputStar from '_shared/InputStar.vue';
import InputString from './InputField/InputString.vue';
import InputBoolean from './InputField/InputBoolean.vue';

export default {
  name: 'answer-form',
  props: {
    title: {
      type: String,
      default: 'Verificando token',
    },
    form: {
      type: Object,
      default: () => ({
        id: null,
        rating: {},
      }),
    },
  },
  components: {
    Alert,
    InputStar,
    InputString,
    InputBoolean,
  },
  data() {
    return {
      model: [],
      submitted: false,
      template: {
        int: 'InputStar',
        string: 'InputString',
        boolean: 'InputBoolean',
      },
    };
  },
  computed: {
    hasErrors() {
      if (this.form.rating.questions) {
        const errors = this.form.rating.questions.filter(field => field.valid === false);
        if (errors.length > 0) {
          return false;
        }
      }
      return null;
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    checkForm() {
      this.submitted = true;
      let valid = true;
      this.form.rating.questions.forEach(row => {
        row.valid = true;
        if (row.value === undefined || row.value === null || row.value === '') {
          row.valid = false;
          valid = false;
        }
      });
      return valid;
    },
    getAnswerValue(row) {
      if (row.type === 'boolean') {
        return row.value ? 'Sim' : 'Não';
      }
      if (row.value) {
        return row.value.toString();
      }
      return null;
    },
    hasErrorFiled(field) {
      if (this.submitted) {
        if (!field.valid) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
    setModel() {
      this.model = [];
      this.form.rating.questions.forEach(row => {
        this.model.push({
          id: null,
          type: row.type,
          value: this.getAnswerValue(row),
          question: row.question,
          rating_has_users_id: this.form.id,
        });
      });
    },
    submit() {
      this.setToggle({ type: 'progress', bool: true });
      if (this.checkForm()) {
        this.setModel();
        RatingService.saveAnswers(this.model, this.$route.params.token)
          .then(() => {
            this.activeAlert({ message: 'Formulário enviado com sucesso', theme: 'success' });
            this.submitted = false;
            window.scrollTo(0, 0);
          })
          .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }))
          .finally(() => this.setToggle({ type: 'progress', bool: false }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
